import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import underConstructionSite from "../../images/underConstructionPage.jpg";

import axios from "axios";
import RoomRegister from "./roomRegister/roomRegister";

import "./watch.css";

const Watch = () => {
	const history = useHistory();
	// const [activeRooms, setActiveRooms] = useState(["chessMaster", "dark room", "nice", "trial", "sdse", "a"]); // PV: ["string"]
	const [activeRooms, setActiveRooms] = useState([]); // PV: ["string"]
	const [chosenRoom, setChosenRoom] = useState("");
	const [isRoomVisible, setRoomVisibility] = useState(false);
	useEffect(() => {
		getRoomActive();
	}, []);

	function getRoomActive() {
		console.log("getRoomActive");
		axios
			.get(`/room/active`)
			.then(res => setActiveRooms(res.data.activeRooms))
			.catch(err => console.log(err));
	}

	function displayListOfRooms() {
		return activeRooms.map((room, index) => (
			<div className={index % 2 == 0 ? "room-container even" : "room-container odd"} key={index}>
				<div className="left">
					<h1 className="room">{room}</h1>
				</div>
				<div className="right">
					<input
						className="watch-btn"
						type="button"
						value="view"
						onClick={e => {
							setChosenRoom(room);
							setRoomVisibility(true);
						}}
					/>
				</div>
			</div>
		));
	}

	return (
		<div className="watch-page">
			<input type="submit" className="logout-btn" value="BACK" onClick={() => history.push("/login")} />
			<div className="watch-container">
				<h1 className="watch-title">WATCH</h1>
				<div className="list-container">
					<div className="refresh" onClick={e => getRoomActive()}>
						REFRESH
					</div>
					{activeRooms.length === 0 ? <h1 className="empty-room">no one is playing right now...</h1> : displayListOfRooms()}
				</div>
				<RoomRegister isRoomVisible={isRoomVisible} setRoomVisibility={setRoomVisibility} rooomName={chosenRoom} />
			</div>
		</div>
	);
};

export default Watch;
